import { css, FlattenSimpleInterpolation } from "styled-components"
import media from "styleguide/styles/media-queries"

export type Size = "XXL" | "XL" | "L" | "M" | "S" | "XS"
const sizes: Size[] = ["XXL", "XL", "L", "M", "S", "XS", "XS"]

export type SizeToCssMapping = { [k in Size]: FlattenSimpleInterpolation }

type Fun = (size: Size) => FlattenSimpleInterpolation

export const genericTextSizes: SizeToCssMapping = {
  XS: css`
    font-size: 13px;
    line-height: 16px;
  `,
  S: css`
    font-size: 14px;
    line-height: 24px;
  `,
  M: css`
    font-size: 16px;
    line-height: 24px;
  `,
  L: css`
    font-size: 18px;
    line-height: 32px;
  `,
  XL: css`
    font-size: 22px;
    line-height: 32px;
  `,
  XXL: css`
    font-size: 28px;
    line-height: 40px;
  `,
}

export const sizeToCss: Fun = size => {
  const ind = sizes.indexOf(size)

  return css`
    ${genericTextSizes[sizes[ind]]}

    ${media.desktop`
      ${genericTextSizes[sizes[ind + 1]]}
    `}

    ${media.tablet`
      ${genericTextSizes[sizes[ind + 1]]}
    `}

    ${media.phone`
      ${genericTextSizes[sizes[ind + 1]]}
    `}
    `
}
